import { types } from "../actions/formLANDUSE";

const initialState = JSON.parse(sessionStorage.getItem("nocFormData")) ? JSON.parse(sessionStorage.getItem("nocFormData")) : {};

export const nocReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_NOC_FORM_FIELD:
      const newState = {
        ...state,
        [action.payload.name]: action.payload.value,
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(newState));
      return newState;
    case types.UPDATE_NOC_FORM_DATA: // Handle bulk update
      const bulkFieldState = {
        ...state,
        ...action.payload, // Merge the entire object
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(bulkFieldState));
      return bulkFieldState;
    case types.UPDATE_OTHERS_DETAILS:
      const updatedOthersState = {
        ...state,
        othersDetails: action.payload,
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(updatedOthersState));
      return updatedOthersState;
    case types.UPDATE_APPLICANT_OTHERS_DETAILS:
      const updatedApplicantOthersState = {
        ...state,
        othersNocDetailsApplicant: action.payload,
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(updatedOthersState));
      return updatedApplicantOthersState;
    default:
      return state;
  }
};
